export default function isViewportEntryData(data) {
  if (data) {
    var hasElementName = typeof data.elementName === 'string';
    var hasRect = typeof data.rect !== 'undefined';
    if (hasRect && hasElementName) {
      return true;
    }
  }
  return false;
}